import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import React from 'react';

import Background from '../background/background.js';
import Workpieces from '../workpieces/workpieces.js';

import fonts from '../fonts/fonts.css';
import styles from './index.module.scss';

import logo from './logo.svg';
import logoEn from './logo-en.svg';
import translations from './translations.yml'

const join = (...classes) => classes.join(' ');

export default ({ data, pathContext }) =>
  <div>
    <Helmet>
      <title>
        ROBERTDENIEROSTAR {pathContext.lang === 'en' ? '– English page' : ''}
      </title>
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <meta name="description" content={translations[pathContext.lang].description} />
      <meta name="keywords" content={translations[pathContext.lang].keywords} />
    </Helmet>

    <div className={styles.sidebar}>

      <img className={join(styles.logo, styles.margin)}
           src={pathContext.lang === 'de' ? logo : logoEn} />

      <div className={join(styles.imprint, styles.margin)}>
        <div className={styles.address}>
          Robert Oberzaucher<br/>
          Großdombra 21<br/>
          A–9872 Millstatt<br/>
        </div>
        <div className={styles.contact}>
          <a className={styles.link} href="tel:+436641334748">+43 (0) 664 133 47 48</a><br/>
          <a className={styles.link} href="mailto:robertdenierostar@aon.at">robertdenierostar@aon.at</a>
        </div>
      </div>

      <div className={join(styles.margin, styles.portrait)}>
        {translations[pathContext.lang].portrait}
        <span> (</span>
        <Link className={styles.link}
              exact
              to="/">
          de
        </Link>
        /
        <Link className={styles.link}
              exact
              to="/en/">
          en
        </Link>
        <span>)</span>
      </div>

      <Workpieces images={data.workpieces.edges.map(edge => edge.node)}
                  lang={pathContext.lang} />
    </div>

    <Background resolutions={data.background.childImageSharp.resolutions} />
  </div>
;

export const query = graphql`
  query Index {
    background: file(relativePath: { eq: "background.jpg" }) {
      childImageSharp {
        ...BackgroundResolutions
      }
    }
    workpieces: allFile(
      filter: {
        extension: { eq: "jpg" }
        sourceInstanceName: { eq: "workpieces" }
      }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          ...WorkpiecesFields
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/index/index.js